import { render } from "./Customizable.vue?vue&type=template&id=263d6fb1"
import script from "./Customizable.vue?vue&type=script&lang=js"
export * from "./Customizable.vue?vue&type=script&lang=js"

import "./Customizable.vue?vue&type=style&index=0&id=263d6fb1&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__